import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';
import { SezioneBeniImmobili } from '../../../models/sezioni/sezione-beni-immobili';
import { BeniImmobiliUpdateComponent } from './beni-immobili-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [beni-immobili-mod-update]',
  templateUrl: 'beni-immobili-mod-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class BeniImmobiliModUpdateComponent {
  @Output() onReturn: EventEmitter<SezioneBeniImmobili> = new EventEmitter<SezioneBeniImmobili>();
  @ViewChild('formBeniUpdateImmobili') modaleAnagrafica: BeniImmobiliUpdateComponent;

  inizializza(urlUpdateAnagrafica: string, sezione: SezioneBeniImmobili, beneImmobile: BenePignoratoImmobile) {
    this.modaleAnagrafica.inizializza(urlUpdateAnagrafica, sezione, beneImmobile);
    openModal('modalmodupdatebeniimmobili');
  }

  createForm() {
    this.modaleAnagrafica.createForm();
  }

  manageModal(sezioneBeniImmobili: SezioneBeniImmobili) {
      closeModal('modalmodupdatebeniimmobili');
      this.onReturn.emit(sezioneBeniImmobili);
  }
}
